var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyTabIcon = function SvgKeyTabIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M4.622 19h10.755A3.615 3.615 0 0 0 19 15.385V4.623A3.623 3.623 0 0 0 15.377 1H4.622A3.63 3.63 0 0 0 1 4.622v10.763A3.62 3.62 0 0 0 4.622 19M2.5 4.622A2.12 2.12 0 0 1 4.622 2.5h10.755A2.12 2.12 0 0 1 17.5 4.622v10.763a2.123 2.123 0 0 1-2.123 2.115H4.622A2.123 2.123 0 0 1 2.5 15.385z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M5.125 11.125h3.188a.19.19 0 0 1 .187.188v1.312a.75.75 0 0 0 1.283.533l2.25-2.25a.75.75 0 0 0 0-1.058L9.783 7.6a.75.75 0 0 0-1.063-.005.75.75 0 0 0-.22.53v1.313a.187.187 0 0 1-.188.187H5.126a.75.75 0 0 0 0 1.5zM14.125 13.375a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 1 0-1.5 0v4.5a.75.75 0 0 0 .75.75"
  })));
};
export { SvgKeyTabIcon as ReactComponent };